import { useMemo } from 'react';
import { type VehicleCycledEnergyRecord } from '../services/battery-monitoring-api/types/battery-monitoring-api';

export type InstalledBatteryVehicle = Pick<VehicleCycledEnergyRecord, 'batteryCapacity'>;

interface UseInstalledBatteriesProperties {
  vehicles: InstalledBatteryVehicle[] | undefined;
}

const useBatteries = ({ vehicles }: UseInstalledBatteriesProperties): string[] => {
  return useMemo<string[]>(() => {
    if (!vehicles) return [];

    const unique = new Set<string>();

    for (const vehicle of vehicles) {
      if (vehicle.batteryCapacity === undefined) continue;

      unique.add(vehicle.batteryCapacity.toString());
    }

    return [...unique].toSorted((a, b) => Number(a) - Number(b));
  }, [vehicles]);
};

export default useBatteries;
